import React from 'react'

const SearchButton = ({setModalOpen}) => {
  return (
    <button className='search-button' onClick={() => setModalOpen(false)}>
      Поиск товаров
    </button>
  )
}

export default SearchButton
